import Cookie from './Cookies';
import { cookiesName, cookieExpiration } from '../constants';

export const normalizeFreeItemId = (id) => {
  if (id === undefined || id === null || id === false) {
    return false;
  }

  return String(id);
};

export const cartFreeItemRemovedIds = () => {
  const value = Cookie.get(cookiesName.offer.freeItemRemoveIntentional);

  if (!value) {
    return new Set();
  }

  return new Set(
    String(value)
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean)
  );
};

export const cartFreeItemSetRemovedIds = (ids = []) => {
  const values = Array.from(
    new Set(Array.from(ids).map(normalizeFreeItemId).filter(Boolean))
  );

  if (values.length) {
    Cookie.set({
      name: cookiesName.offer.freeItemRemoveIntentional,
      value: values.join(','),
      expires: 10,
      path: '/',
    });
  } else {
    Cookie.remove({
      name: cookiesName.offer.freeItemRemoveIntentional,
    });
  }

  return new Set(values);
};

export const cartFreeItemParameterCookieName = (parameter) =>
  `${cookiesName.offer.freeItemByParameterPrefix}${parameter}`;

export const cartFreeItemParameterInUrl = (item) => {
  if (!item?.parameter) {
    return false;
  }

  return (
    new URL(window.location.href).searchParams.get(item.parameter) !== null
  );
};

export const cartFreeItemParameterIsActive = (item) => {
  if (!item?.parameter) {
    return true;
  }

  return (
    cartFreeItemParameterInUrl(item) ||
    Cookie.get(cartFreeItemParameterCookieName(item.parameter))
  );
};

export const cartFreeItemRememberParameter = (item) => {
  if (
    !item?.parameter ||
    (!item?.data && !item?.product) ||
    !cartFreeItemParameterInUrl(item)
  ) {
    return false;
  }

  const cookieName = cartFreeItemParameterCookieName(item.parameter);

  if (Cookie.get(cookieName)) {
    return false;
  }

  Cookie.set({
    name: cookieName,
    value: true,
    expires: cookieExpiration[cookiesName.offer.freeItemByParameterPrefix],
    path: '/',
  });

  return true;
};

export const cartFreeItemRememberParameters = (items = []) => {
  return (Array.isArray(items) ? items : []).reduce(
    (remembered, item) =>
      remembered + (cartFreeItemRememberParameter(item) ? 1 : 0),
    0
  );
};
